module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group formly-input",
    class: [_vm.to.inputType, _vm.to.wrapperClasses, {
      'formly-has-value': _vm.model[_vm.field.key],
      'formly-has-focus': _vm.form[_vm.field.key].$active,
      'has-error has-danger': _vm.hasError
    }]
  }, [(_vm.to.label) ? _c('label', {
    attrs: {
      "for": _vm.to.id ? _vm.to.id : null
    }
  }, [_vm._v(_vm._s(_vm.to.label))]) : _vm._e(), _vm._v(" "), _c('vue-chosen', {
    attrs: {
      "multiple": false,
      "options": _vm.field.options
    },
    model: {
      value: (_vm.model[_vm.field.key]),
      callback: function($$v) {
        _vm.$set(_vm.model, _vm.field.key, $$v)
      },
      expression: "model[field.key]"
    }
  }), _vm._v(" "), _c('error-display', {
    attrs: {
      "form": _vm.form,
      "field": _vm.field.key
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56028be5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/elements/Select.vue
// module id = 1102
// module chunks = 0